module.exports = "*:not(.fa) {\n  font-family: \"Cairo\", sans-serif;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/financial/fines-view/modals/add-fine-form-modal/add-fine-form-modal.component.css
// module id = ./src/app/financial/fines-view/modals/add-fine-form-modal/add-fine-form-modal.component.css
// module chunks = main